import { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, HeartHandshake, LockKeyhole } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { ClientPinDialog } from "@/components/care/ClientPinDialog";
import { ClientGrid } from "@/components/care/ClientGrid";

export default function KioskClientsPage() {
  const nav = useNavigate();
  const { state } = useLocation();
  const [pin, setPin] = useState(state?.pin || "");
  const [staff, setStaff] = useState(state?.staff || null);
  const [clients, setClients] = useState([]);
  const [q, setQ] = useState("");

  const load = useCallback(async () => {
    try { const { data } = await api.get("/clients"); setClients(data); } catch { /* ignore */ }
  }, []);
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, [load]);

  // auto-lock after 3 idle minutes
  useEffect(() => {
    if (!staff) return;
    const t = setTimeout(() => { setStaff(null); setPin(""); toast("Locked — enter your PIN again"); }, 3 * 60 * 1000);
    return () => clearTimeout(t);
  }, [staff, clients]);

  const shown = clients.filter((c) => !q || c.full_name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col safe-area" data-testid="kiosk-clients-page">
      <header className="flex items-center justify-between px-8 py-5 bg-white border-b border-slate-200">
        <button onClick={() => nav("/kiosk")} data-testid="kiosk-clients-back" className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100">
          <ArrowLeft className="h-4 w-4" /> Kiosk
        </button>
        <div className="flex items-center gap-2 font-display text-xl font-bold text-slate-900"><HeartHandshake className="h-6 w-6 text-primary" /> Client check-in</div>
        {staff ? (
          <button onClick={() => { setStaff(null); setPin(""); }} data-testid="kiosk-clients-lock" className="inline-flex items-center gap-2 rounded-full bg-emerald-50 border border-emerald-200 px-4 py-2 text-sm text-emerald-800">
            <LockKeyhole className="h-4 w-4" /> {staff.name} · Lock
          </button>
        ) : <span className="w-24" />}
      </header>

      {!staff ? (
        <ClientPinDialog open onClose={() => nav("/kiosk")} onIdentified={(data, value) => { setStaff(data); setPin(value); }} />
      ) : (
        <main className="flex-1 p-6 md:p-8 space-y-4">
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search clients…" data-testid="kiosk-clients-search"
            className="w-full max-w-md h-12 rounded-xl border border-slate-200 bg-white px-4 text-base outline-none focus:border-primary" />
          <ClientGrid clients={shown} pin={pin} big onChanged={load} onStayDone={() => { setStaff(null); setPin(""); nav("/kiosk"); }} />
        </main>
      )}
    </div>
  );
}
